import { UI } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import * as NB from 'native-base';
import React from 'react';
import { useRecoilValue } from 'recoil';

import { hasCustomerItem } from '../../../../store/customer/selector';
import { orderItemState } from '../../../../store/order/atom';
import {
  hasOrderChannelsSelector,
  hasOrderItem,
  orderInteractionChannelAuditRequest,
} from '../../../../store/order/selectors';
import { productItemState } from '../../../../store/product/atom';
import { hasProductItem } from '../../../../store/product/selectors';
import { sessionState } from '../../../../store/session/atom';

export interface FooterProps {
  onCancel: () => void;
  onSend: () => void;
}

export const Footer: React.FC<FooterProps> = (props) => {
  const hasCustomer = useRecoilValue(hasCustomerItem);
  const hasProduct = useRecoilValue(hasProductItem);
  const hasOrder = useRecoilValue(hasOrderItem);
  const hasOrderChannels = useRecoilValue(hasOrderChannelsSelector);
  const interactionChannel = useRecoilValue(orderInteractionChannelAuditRequest);
  const productItem = useRecoilValue(productItemState);
  const orderItem = useRecoilValue(orderItemState);
  const currentProduct = productItem.current;
  const productType = currentProduct?.type;
  const operationType = currentProduct?.operationType;
  const isFixedIncomeSale = operationType === 'sell' && productType === 'FixedIncome';
  const hasStructuredOperationOptionSelected = !!currentProduct.billingTypeId;

  const { userProfile } = useRecoilValue(sessionState);
  const isManager = !!(userProfile?.isGestor && userProfile?.idTipoParceiro !== 4);

  const isMobile = NB.useBreakpointValue({
    base: true,
    sm: false,
  });

  const hasOrderValueValid = currentProduct.orderValue && currentProduct.orderValue > 0;
  const cancelOrderButtonIsDisabled = !hasCustomer;
  const totalPrice =
    currentProduct.orderValue &&
    currentProduct.orderQuantity &&
    currentProduct.orderValue * currentProduct.orderQuantity;

  const interactionChannelCheck = interactionChannel !== undefined;

  const defaultValidation = isManager
    ? hasCustomer && hasProduct && hasOrder && hasOrderValueValid
    : hasCustomer &&
      hasProduct &&
      hasOrder &&
      hasOrderChannels &&
      interactionChannelCheck &&
      hasOrderValueValid;

  const fixedIncomeSaleOrderIsValid = defaultValidation && hasOrderValueValid;

  const totalPriceEquityIsValid = totalPrice && totalPrice > 0 && totalPrice < 1000000;
  const fixedIncomeOrderIsValid = isFixedIncomeSale
    ? fixedIncomeSaleOrderIsValid
    : defaultValidation;
  const equityOrderIsValid = totalPriceEquityIsValid && defaultValidation;
  const structuredOperationOrderIsValid = defaultValidation && hasStructuredOperationOptionSelected;

  const isDisabledButton = {
    Equity: !equityOrderIsValid,
    FixedIncome: !fixedIncomeOrderIsValid,
    Fund: !defaultValidation,
    DirectTreasury: !defaultValidation,
    StructuredOperations: !structuredOperationOrderIsValid,
  };

  if (orderItem.valueAdjustedDueSuitability && !orderItem.acceptedTermForValueAdjusted) {
    Object.keys(isDisabledButton).forEach((key) => {
      if (key === productType) {
        isDisabledButton[key] = true;
      }
    });
  }

  const isReapplication = currentProduct?.hasPosition;

  if (isMobile) {
    return (
      <NB.Box py={Spacing['inset.sm']} px={Spacing['inline.xxxs']}>
        <UI.Button
          testID="qa"
          variant={isReapplication ? 'primary' : 'callToAction'}
          isDisabled={isDisabledButton[productType] ?? isDisabledButton.FixedIncome}
          onPress={props.onSend}>
          {isReapplication ? 'Reaplicar' : 'Enviar'}
        </UI.Button>
      </NB.Box>
    );
  }

  return (
    <NB.Box py={Spacing['inset.sm']}>
      <NB.View
        flexDirection={'row'}
        alignItems={'center'}
        w={'100%'}
        minW={'container'}
        flex={1}
        justifyContent={'space-between'}>
        <NB.Spacer />
        <NB.HStack space={Spacing['inline.xxxs']}>
          <UI.Button
            testID="qa"
            variant="secondary"
            isDisabled={cancelOrderButtonIsDisabled}
            onPress={props.onCancel}>
            Cancelar
          </UI.Button>
          <UI.Button
            testID="qa"
            variant={isReapplication ? 'primary' : 'callToAction'}
            isDisabled={isDisabledButton[productType] ?? isDisabledButton.FixedIncome}
            onPress={props.onSend}>
            {isReapplication ? 'Reaplicar' : 'Enviar'}
          </UI.Button>
        </NB.HStack>
      </NB.View>
    </NB.Box>
  );
};
